<!--
 * @Author: 汪满青
 * @Date: 2025-01-07 10:23:47
 * @LastEditors: zouxin
 * @LastEditTime: 2025-02-20 16:44:05
 * @Description: 我的模版Card卡片
 -->
 <template>
  <div>
    <div class="card-list" v-if="dataList.length !== 0">
      <a-card v-for="item in dataList" :key="item.id" class="prj-card">
        <template #cover>
          <div class="prj-card-img">
            <img :src="item.coverUrl ? (imgHost + item.coverUrl) : homeImg" alt="img" class="hover-mask" />
            <div class="example-status hover-show">
              <a-button
                v-show="isShowBtn(item.itemStatus, 'del', cardType) && isDelPermitted"
                type="primary"
                @click="() => delHandle(item)"
              >{{$t('project.delete')}}</a-button>

              <a-button
                v-show="isShowBtn(item.itemStatus, 'use', cardType)"
                type="primary"
                @click="() => useHandle(item)"
              >{{$t('project.use')}}</a-button>

              <a-button
                v-show="isShowBtn(item.itemStatus, 'preview', cardType) && isPreviewPermitted"
                type="primary"
                @click="() => previewHandle(item)"
                class="delBtn"
              >{{$t('project.preview')}}</a-button>

              <a-dropdown @click="(value) => _downHandle(value, item)" :trigger="['hover']">
                <a-button type="primary" v-show="isShowBtn(item.itemStatus, 'down', cardType)">{{$t('project.download')}}</a-button>
                <a-menu slot="overlay">
                  <a-menu-item v-for="(versionItem, versionIndex) in item.versionList" :key="versionIndex">
                    V{{ versionItem }}
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>

            <a-tag
              v-show="cardType === 'template'"
              :color="reviewStatus[item.itemStatus]"
              class="hover-status"
            >{{ $t(item.itemStatus) || 'project.status' }}</a-tag>
            <a-tag
              v-show="cardType === 'download' || cardType === 'collection'"
              class="hover-status"
              color="#78bf03"
            >{{ item.integral == 0 ? $t('project.free') : item.integral + $t('project.integral') }}</a-tag>
          </div>
        </template>
        <a-card-meta>
          <template #description>
            <div class="prj-card-bottom">
              <div style="width: 100%">
                <div :title="item.name" class="prj-card-bottom-name">
                  <div class="prj-card-bottom-name-project">{{ item.name }}</div>
                  <div
                    v-if="(cardType === 'download' || cardType === 'collection') && item.supplierName"
                    class="prj-card-bottom-name-uploader"
                  >
                    <a-icon type="user" />
                    {{ item.supplierName || '上传人' }}
                  </div>
                  <a-dropdown>
                    <a-icon type="ellipsis" />
                    <a-menu slot="overlay">
                      <a-menu-item
                          v-if="isShowBtn(item.itemStatus, 'preview', cardType) && isPreviewPermitted"
                          key="preview"
                          @click="previewHandle(item)"
                        >
                          {{$t('project.preview')}}
                      </a-menu-item>
                      <a-menu-item
                        v-for="(v,menuIndex) in filterProjectMenu"
                        v-show="v.show && v.label !== 'project.download'"
                        :key="menuIndex"
                        @click="handleSelectClick(v, item)"
                      >
                        {{ $t(v.label) }}
                      </a-menu-item>
                      <template v-if="cardType === 'collection'">
                        <a-menu-item
                          v-if="directShowCencelCollect || item.collectId"
                          key="cancelCollection"
                          @click="_cancelCollection(item)"
                        >
                          取消收藏
                        </a-menu-item>
                        <a-menu-item
                          v-else
                          key="handleCollection"
                          @click="_Collection(item)"
                        >
                          收藏
                        </a-menu-item>
                      </template>
                      <a-menu-item
                        v-for="v in filterProjectMenu"
                        v-show="v.show && v.label === 'project.download'"
                        :key="v.event"
                      >
                        <a-dropdown>
                          <span>{{$t('project.download')}}</span>
                          <a-menu slot="overlay">
                            <a-menu-item
                              v-for="(versionItem, versionIndex) in item.versionList"
                              :key="versionIndex"
                              @click="handleDownSelect(versionItem, item)"
                            >
                              V{{ versionItem }}
                            </a-menu-item>
                          </a-menu>
                        </a-dropdown>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </div>

                <div v-if="cardType === 'template'" :title="item.publishTime" class="prj-card-bottom-name">
                  <span>{{ item.publishTime && item.publishTime.substring(0,10) }}</span>
                  <div v-if="item.itemStatus === '已上架'">
                    <span class="prj-card-bottom-name-count"><a-icon type="eye" />{{ item.browseCnt }}</span>
                    <span class="prj-card-bottom-name-count" @click="collAndUnColl(item)"><a-icon type="heart" :class="[item.collectId ? 'heart-fill-red' : '']" />{{ item.collectCnt }}</span>
                    <span class="prj-card-bottom-name-count"><a-icon type="download" />{{ item.downloadCnt }}</span>
                  </div>
                </div>

                <div
                  v-if="cardType === 'download' || cardType === 'collection'"
                  :title="item.publishTime"
                  class="prj-card-bottom-name"
                >
                  <span>{{ item.publishTime && item.publishTime.substring(0,10) }}</span>
                  <div>
                    <span class="prj-card-bottom-name-count"><a-icon type="eye" />{{ item.browseCnt }}</span>
                    <span class="prj-card-bottom-name-count" @click="collAndUnColl(item)"><a-icon type="heart" :class="[item.collectId ? 'heart-fill-red' : '']" />{{ item.collectCnt }}</span>
                    <span class="prj-card-bottom-name-count"><a-icon type="download" />{{ item.downloadCnt }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </a-card-meta>
      </a-card>
    </div>
    <a-empty v-else class="emptycss" :image="emptyDataImg" :description="$t('project.noSearchResults')"/>
    <!-- 分页组件独占一行 -->
    <div class="pagination-container">
      <a-pagination
        v-if="pageTotal !== 0"
        :total="pageTotal"
        :show-total="(total) => $t('project.total', { total })"
        show-size-changer
        @change="pageNumChange"
        @showSizeChange="pageSizeChange"
      />
    </div>
  </div>
</template>

<script>
import homeImg from '@/assets/images/default-card.png'
import emptyDataImg from '@/assets/images/empty-data.png'
import { collageApi, cancelCollage, downloadApi } from '@/api/myTemplate'
import { message, Modal } from 'ant-design-vue'
import { hasPermission } from '@/utils/auth'

export default {
  name: 'TemplateCard',
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    cardType: {
      type: String,
      default: 'template'
    },
    directShowCencelCollect: {
      type: Boolean,
      default: false
    },
    pageTotal: {
      type: Number,
      default: 0
    },
    loadDataFunc: {
      type: Function,
      default: () => {}
    },
    previewHandle: {
      type: Function,
      default: () => {}
    },
    useHandle: {
      type: Function,
      default: () => {}
    },
    delHandle: {
      type: Function,
      default: () => {}
    },
    downHandle: {
      type: Function,
      default: () => {}
    },
    handleCollection: {
      type: Function,
      default: () => {}
    },
    cancelCollection: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      homeImg,
      emptyDataImg,
      reviewStatus: {
        'project.pendingReview': '#258F9D',
        'project.sold': '#259D33',
        'project.reviewNotPassed': '#C64331',
        'project.soldOff': '#5F5F60'
      },
      projectMenu: [
        // { label: '预览', event: 'previewHandle', show: true },
        { label: 'project.use', event: 'useHandle', show: this.cardType === 'download' },
        { label: 'project.delete', event: 'delHandle', show: this.cardType === 'download' || this.cardType === 'template', authCode: 'del_template_web' },
        { label: 'project.download', event: 'downHandle', show: this.cardType === 'collection' }
      ]
    }
  },
  computed: {
    imgHost() {
      return process.env.VUE_APP_CTYUN_URL
    },
    isPreviewPermitted() {
      return hasPermission('preview_template_web')
    },
    isDelPermitted() {
      return hasPermission('del_template_web')
    },
    filterProjectMenu() {
      return this.projectMenu.filter(item => hasPermission(item.authCode))
    }
  },
  methods: {
    isShowBtn(status, type, cardType) {
      if (type === 'preview') {
        if (cardType === 'template') {
          switch (status) {
            case 'project.pendingReview':
              return true
            case 'project.sold':
              return true
            case 'project.reviewNotPassed':
              return true
            case 'project.soldOff':
              return false
            default:
              return false
          }
        }
        if (cardType === 'download') {
          return true
        }
        if (cardType === 'collection') {
          return true
        }
      }
      if (type === 'del') {
        if (cardType === 'template') {
          switch (status) {
            case 'project.pendingReview':
              return true
            case 'project.sold':
              return false
            case 'project.reviewNotPassed':
              return true
            case 'project.soldOff':
              return true
            default:
              return false
          }
        }
        if (cardType === 'download') {
          return false
        }
      }

      if (type === 'use') {
        if (cardType === 'template') {
          return false
        }
        if (cardType === 'download') {
          return true
        }
      }

      if (type === 'down') {
        if (cardType === 'collection') {
          return true
        }
      }
      return false
    },
    handleSelectClick(v, item) {
      this[v.event](item)
    },
    async _Collection(item) {
      try {
        const res = await collageApi({templateId: item.templateId})
        if(res.status === 0){
          message.success('收藏成功')
          this.loadDataFunc()
          this.handleCollection && this.handleCollection()
        } else {
          message.error(res.message)
        }
      } catch (error) {
        console.log('收藏失败', error)
      }
    },
    async _cancelCollection(item) {
      try {
        const res = await cancelCollage({templateId: item.templateId})
        if(res.status === 0){
          message.success('取消收藏成功')
          this.loadDataFunc()
          this.cancelCollection && this.cancelCollection()
        } else {
          message.error(res.message)
        }
      } catch (error) {
        console.log('取消收藏失败', error)
      }
    },
    // 红心-收藏与不收藏
    collAndUnColl (item) {
      if(item.collectId) {
        this._cancelCollection(item)
      } else {
        this._Collection(item)
      }
    },
    async _downHandle(version, item) {
      try {
        const res = await downloadApi({templateId: item.templateId, version})
        if(res.status === 0){
          if(res.data.isRecovery === 1) {
            Modal.success({
              title: '下载完成',
              content: '正在从回收站恢复',
              centered: true
            })
          } else {
            message.success('下载成功')
          }
          this.downHandle && this.downHandle(version, item)
        } else {
          message.error(res.message)
        }
      } catch (error) {
        console.log('下载失败', error)
      }
    },
    handleDownSelect(version, item) {
      this._downHandle(version, item)
    },
    pageNumChange(page) {
      this.loadDataFunc(page)
    },
    pageSizeChange(current, size) {
      this.loadDataFunc(1, size)
    }
  }
}
</script>

<style lang="less" scoped>
.card-list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, 303px);
  column-gap: 30px;
  // justify-content: space-between;
  justify-content: start;
  // 添加底部边距，防止固定分页组件遮挡最后一行卡片
  padding-bottom: 80px;
  
  ::v-deep .ant-card-bordered {
     border:1px solid rgb(72,72,73);
  }
  .prj-card {
    margin-bottom: 50px;
    background: var(--primary-bg-color);
    border-radius: 8px;
    cursor: pointer;
    :deep(.arco-card-cover) {
      border-radius: 8px;
    }

    &-img {
      position: relative;
      height: 151px;
      border-bottom: 1px solid var(--lv1-border-color);
      overflow: hidden;

      img {
        position: absolute;
        min-width: 100%;
        min-height: 100%;
        max-width: 100%;
        max-height: 100%;
      }

      .example-status {
        position: absolute;
        width: 100%;
        height: 50%;
        top: 35%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;

        & button {
          height: 32px;
          border-radius: 4px;
          margin-right: 15px;
        }

        & button:first-child {
          background-color: #4D3131;
          color: #F76964;
          border-radius: 4px;
          border:none;
        }
      }

      .hover-status {
        position: absolute;
        top: 5%;
        right: 3%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--lv1-text-color);
        border-radius: 30px;
      }

      .hover-show {
        opacity: 0;
      }
    }

    &-bottom {
      display: flex;
      justify-content: space-between;
      color: var(--lv1-text-color);
      font-size: 14px;
      align-items: center;

      &-name {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        justify-content: space-between;

        &-project {
          width: 70%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &-uploader {
          width: 30%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &-count{
          margin-right: 16px;
          &:last-of-type {
            margin-right: 0;
          }
          .anticon{
            margin-right: 5px;
          }
        }
      }

      &-name:last-child {
        margin-top: 8px;

        span {
          font-size: 12px;
          // margin-right: 10px;
        }
      }
    }

    &:hover {
      border: 1px solid var(--lv3-theme-color);

      .hover-show {
        opacity: 1;
      }

      .hover-mask {
        opacity: 0.3;
      }
    }
  }
}

.prj-card-bottom-name-uploader {
  width: auto !important;
  margin-right: 15px;
}

.emptycss {
  margin: 0 auto;
  margin-top: 200px;
  :deep(.ant-empty-image img) {
    width: 143.48px;
    height: 146px;
  }
}

// 分页组件固定在页面右下角的样式
.pagination-container {
  position: fixed;
  bottom: 0px;
  right: 20px;
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: #17171a;
  height: 80px;
  width: 80%;
}

.heart-fill-red {
  color: red;
}
</style>